import { SET_REGION, UPDATE_FILTER_SEARCH_TERM, UPDATE_DIET_TYPE, UPDATE_MEAL_TYPE, UPDATE_SORTING, SHOW_MOBILE_MEALS, SEARCHING } from './mutations'

const state = {
  region: 'North America',
  filterSearchTerm: '',
  diets: 'All',
  meals: 'All',
  sortBy: 'Alphabetical',
  showMobileMeals: false,
  searching: false
}

const getters = {

}

const mutations = {
  [SET_REGION] (state, region) {
    state.region = region
  },
  [UPDATE_FILTER_SEARCH_TERM] (state, val) {
    state.filterSearchTerm = val
  },
  [UPDATE_DIET_TYPE] (state, val) {
    state.diets = val
  },
  [UPDATE_MEAL_TYPE] (state, val) {
    state.meals = val
  },
  [UPDATE_SORTING] (state, val) {
    state.sortBy = val
  },
  [SHOW_MOBILE_MEALS] (state) {
    state.showMobileMeals = true
  },
  [SEARCHING] (state, val) {
    state.searching = val
  }
}

const actions = {

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
